Ext.define('SA.data.QueryManager', {
    cacheSize: 100,
    page: 1,
    pageSize: 10,

    constructor(cfg) {
        Object.assign(this, cfg);

        this.queryCache = this.queryCache || {};
        this.queryList = this.queryList || [];

        this.refresh = SA.createBuffered(this.refresh, 1);
        this.runQuery = SA.createBuffered(this.runQuery, 250);
    },

    and(where) {
        if (where[0].toLowerCase() === 'and') {
            where = where.slice(1);
        }

        if (where.length <= 1) {
            return where[0];
        }

        return ['and'].concat(where);
    },

    clearCache() {
        var cache = this.queryCache;

        this.queryList.length = 0;

        Object.keys(cache).forEach(key => {
            delete cache[key];
        });

        if (this.query) {
            this.refresh();
        }
    },

    destroy() {
        if (!this.isDestroyed) {
            this.onDestroy();
            this.isDestroyed = true;
        }
    },

    getPage() {
        return this.page;
    },

    getPageSize() {
        return this.pageSize;
    },

    isCachedQuery(query) {
        if (!query) {
            return false;
        }

        return SA.data.Query.from(query).getHash() in this.queryCache;
    },

    onDestroy() {
        this.queryCache = null;
        this.queryList = null;
        this.query = null;
    },

    onSuccess(response) {
        Ext.callback(this.onResults, this.scope || this, [this.prepareResponse(response)]);
    },

    prepareResponse: Ext.identityFn,

    refresh() {
        var query = this.buildQuery();

        if (!query) {
            this.query = null;

            Ext.callback(this.onResults, this.scope || this, [this.prepareResponse({
                facets: {},
                results: [],
                total: 0
            })]);

            return;
        }

        query = this.query = this.updateCache(SA.data.Query.from(query));

        query.addFailure(() => {
            if (query !== this.query) {
                return;
            }

            Ext.callback(this.onFailure, this.scope || this);
        });

        query.addSuccess(response => {
            if (query !== this.query) {
                return;
            }

            this.onSuccess(response);
        });

        this.runQuery();

        Ext.callback(this.beforeQuery, this.scope || this);
    },

    runQuery() {
        var query = this.query;

        if (query) {
            query.run();
        }
    },

    setPage(page) {
        this.page = page;

        this.refresh();
    },

    updateCache(query) {
        var cache = this.queryCache,
            list = this.queryList,
            hash = query.getHash();

        if (cache[hash]) {
            query = cache[hash];
            Ext.Array.remove(list, query);
        }

        cache[hash] = query;
        list.push(query);

        if (list.length > this.cacheSize) {
            delete cache[list.shift().getHash()];
        }

        return query;
    }
});
